import Swiper from 'swiper';
import 'swiper/css';
import { Navigation } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="depoimentos"]');

class Depoimentos {

    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach(component => {

            const swiperComponent = component.querySelector('.swiper');
            if (!swiperComponent) return;

            this.initSwiper(component, swiperComponent);

        });
    }

    initSwiper(component, swiperComponent) {

        const previews = component.querySelectorAll('.preview-img');

        const swiper = new Swiper(swiperComponent, {

            modules: [Navigation],

            loop: true,
            slidesPerView: 1,

            navigation: {
                nextEl: component.querySelector('.swiper-button-next'),
                prevEl: component.querySelector('.swiper-button-prev'),
            },

            on: {
                init: (swiper) => updatePreview(swiper),
                slideChange: (swiper) => updatePreview(swiper)
            }

        });

        function updatePreview(swiper) {

            const total = previews.length;
            const active = swiper.realIndex;

            let prev = active - 1;
            let next = active + 1;

            if (prev < 0) prev = total - 1;
            if (next >= total) next = 0;

            previews.forEach(el => {
                el.style.display = 'none';
                el.style.order = '';
                el.classList.remove('current');
            });

            previews[prev].style.display = '';
            previews[prev].style.order = '1';

            previews[active].style.display = '';
            previews[active].style.order = '2';
            previews[active].classList.add('current');

            previews[next].style.display = '';
            previews[next].style.order = '3';

        }

        previews.forEach(el => {

            const index = parseInt(el.dataset.index);

            el.addEventListener('click', () => {
                swiper.slideToLoop(index);
            });

        });

    }

}

(() => {
    if (MODULE.length) {
        new Depoimentos();
    }
})();

export default Depoimentos;